import {LicensesFeatureContactCountInterface} from '@shared/interface';

/**
 * @description
 * Interface of summary data list
 */
export interface MkadResumeDataListInterface<T> {
  id: T;
  name: string;
}

export interface MkadSummaryListInterface {
  id: number;
  description: string;
}

export enum MkadLicenseEnum {
  user = 'user',
  device = 'device',
  contact = 'contact'
}

export interface MkadGroupParamInterface {
  customer: number;
}

export interface MkadLicensesParamInterface {
  filter: MkadLicenseEnum;
}

export interface MkadSummaryContactListInterface extends Omit<MkadResumeDataListInterface<number>, 'name'>  {
  licenses: LicensesFeatureContactCountInterface;
  description: string;
}
